export default __webpack_public_path__ + "static/media/fontainebleau5.df6cea33.jpg";